import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Component that extracts JWT token from URL query parameter
 * after OIDC authentication callback from backend.
 * 
 * The backend redirects to /?token=xxx after successful authentication.
 * This component extracts the token, stores it, and cleans up the URL.
 */
export default function TokenExtractor() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    
    if (token) {
      console.log("Token received from backend authentication");
      
      // Store token in localStorage
      localStorage.setItem("token", token);
      
      // Remove token from URL for security
      params.delete("token");
      const newSearch = params.toString();
      const newUrl = location.pathname + (newSearch ? `?${newSearch}` : "");
      
      // Navigate to clean URL without token and reload
      navigate(newUrl, { replace: true });
      
      // Reload to update authentication state throughout the app
      window.location.href = newUrl || "/";
    }
  }, [location, navigate]);

  return null;
}
